module.exports = __webpack_public_path__ + "static/media/in_a_week_13.369a3aa2.jpg";